import { NavLink, Outlet } from 'react-router-dom';

import css from './MainPageFrame.module.css';

function MainPageFrame({data}) {
    return (
        <div className={css.main}>
            <div className={css.menu}>
                <nav className={css.nav}>
                    <NavLink to={data.address}>{data.title}</NavLink>
                </nav>
                {/* <nav className={css.nav}>
                    <NavLink to="/contract/details">Details</NavLink>
                </nav> */}
            </div>
            <Outlet />
        </div>
    );
}

export default MainPageFrame;